<template lang='pug' src='./custom-about-office.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  data () {
    return {
      swiperOption: {
        slidesPerView: 3,
        centeredSlides: true,
        breakpoints: {
          610: {
            slidesPerView: 1,
            spaceBetween: 15
          },
          880: {
            slidesPerView: 2,
            spaceBetween: 10
          }
        },
        spaceBetween: 1,
        speed: 700,
        loop: true,
        navigation: {
          nextEl: '.custom-about-office__next',
          prevEl: '.custom-about-office__prev'
        }
      }
    }
  },
  props: ['props'],
  components: {
    Icon,
    swiper,
    swiperSlide
  }
}
</script>



// WEBPACK FOOTER //
// custom-about-office.vue?57e1d9a4